export default {

    setData(state, { objName, data }) {

        state[objName] = data;

    }

};